/**
 * TableCommandButton  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { CommandButton, ICommandButtonProps } from "../Button/CommandButton";
import { BEM } from "@adapptio/lib-components";

export interface ITableCommandButtonProps extends ICommandButtonProps {}

export const TableCommandButton: React.FC<ITableCommandButtonProps> = (props) => {
	const baseClass = BEM("edt-table-command-button");

	return <CommandButton {...props} baseClass={baseClass} />;
};
